const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

const DEFAULT_LOCALE = "en-US";

export function formatTimestamp(
  date: string | number | Date | null | undefined,
  locale: string = DEFAULT_LOCALE
): string {
  if (!date) return "";
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return "";
  return new Intl.DateTimeFormat(locale, DATE_FORMAT_OPTIONS).format(parsed);
}
